var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.line},[_c('span',{class:_vm.$style.lineFill})])
}
var staticRenderFns = []

export { render, staticRenderFns }